module.exports = __webpack_public_path__ + "fonts/iconfont.f25a738c.woff";